// @ts-check
import React from 'react';
import TimeMaskInput from 'shared/containers/BulmaFields/TimeMaskField';
import { DateMaskInput } from 'shared/containers/portal_layout/HForm';

const TimeRangeFields = () => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <div style={{ margin: 4 }}>
      <DateMaskInput name="selectionStartDate" className="input bulma__input input-small" />{' '}
    </div>
    <div style={{ margin: 4 }}>
      <TimeMaskInput name="selectionStartTime" className="input-small" placeholder="09:00 am" />
    </div>
    <div style={{ margin: 4, fontSize: 16, lineHeight: 2.1 }}>to</div>
    <div style={{ margin: 4 }}>
      <TimeMaskInput name="selectionEndTime" className="input-small" placeholder="09:00 am" />
    </div>
    <div style={{ margin: 4 }}>
      <DateMaskInput name="selectionEndDate" className="input bulma__input input-small" />
    </div>
  </div>
);

TimeRangeFields.displayName = 'TimeRangeFields';

export default TimeRangeFields;
